import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueParticles from 'vue-particles'
import routerwap from './router/routerwap.js'
import '@/assets/styles/common.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/js/jquery.min.js'
import '@/assets/js/viewport.js'
import util from '@/utils/util' //一些公用的方法
let cureRouter = null
Vue.prototype.$poublicfun = util
Vue.use(VueParticles)
if (util.judgeEquipment()) {
    cureRouter = routerwap
} else {
    cureRouter = router
}

Vue.config.productionTip = false
new Vue({
    router: cureRouter,
    store,
    render: h => h(App)
}).$mount('#app')